export const photographyServices = [
  { id: 'wedding', icon: 'ri-heart-3-line' },
  { id: 'pre-wedding', icon: 'ri-camera-lens-line' },
  { id: 'baby', icon: 'ri-parent-line' },
  { id: 'videography', icon: 'ri-video-line' },
  { id: 'corporate', icon: 'ri-building-2-line' },
  { id: 'portrait', icon: 'ri-user-star-line' },
]

export const printingServices = [
  { id: 'framing', icon: 'ri-image-2-line' },
  { id: 'visiting-card', icon: 'ri-id-card-line' },
  { id: 'id-card', icon: 'ri-profile-line' },
  { id: 'pamphlet', icon: 'ri-file-paper-2-line' },
  { id: 'brochure', icon: 'ri-booklet-line' },
  { id: 'flex', icon: 'ri-layout-masonry-line' },
]

export const photographyPackages = [
  { id: 'pk1', icon: 'ri-heart-3-line', popular: false },
  { id: 'pk2', icon: 'ri-vip-crown-line', popular: true },
  { id: 'pk3', icon: 'ri-parent-line', popular: false },
  { id: 'pk4', icon: 'ri-building-2-line', popular: false },
]